/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Detail_ErrorInputs */

const id_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesalahan memuat detail perubahan`)
};

const ms_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat memuatkan butiran perubahan`)
};

const da_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejl ved indlæsning af ændringsdetaljer`)
};

const de_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden der Änderungsdetails`)
};

const en_us2_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading change details`)
};

const es_es2_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar los detalles del cambio`)
};

const es_mx2_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar los detalles del cambio`)
};

const fil_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error sa pag-load ng detalye ng pagbabago`)
};

const fr_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement des détails de la modification`)
};

const it_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore nel caricamento dei dettagli della modifica`)
};

const hu_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba a változás részleteinek betöltésekor`)
};

const nl_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout bij laden van wijzigingsdetails`)
};

const no_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feil ved lasting av endringsdetaljer`)
};

const pl_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd ładowania szczegółów zmiany`)
};

const pt_br2_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao carregar detalhes da alteração`)
};

const pt_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao carregar detalhes da alteração`)
};

const ro_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare la încărcarea detaliilor modificării`)
};

const fi_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virhe ladattaessa muutoksen tietoja`)
};

const sv_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel vid inläsning av ändringsdetaljer`)
};

const vi_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi khi tải chi tiết thay đổi`)
};

const tr_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik detayları yüklenirken hata oluştu`)
};

const cs_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba při načítání podrobností změny`)
};

const bg_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грешка при зареждане на детайлите на промяната`)
};

const ru_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при загрузке деталей изменения`)
};

const uk_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка завантаження деталей зміни`)
};

const ar_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ في تحميل تفاصيل التغيير`)
};

const hi_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन विवरण लोड करने में त्रुटि`)
};

const th_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาดในการโหลดรายละเอียดการเปลี่ยนแปลง`)
};

const ja_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更詳細の読み込みエラー`)
};

const zh_cn2_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载更新详情出错`)
};

const zh_hant1_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`載入更新詳情出錯`)
};

const ko_changelog_detail_error = /** @type {(inputs: Changelog_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 상세 정보를 불러오는 중 오류 발생`)
};

/**
* | output |
* | --- |
* | "Error loading change details" |
*
* @param {Changelog_Detail_ErrorInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const changelog_detail_error = /** @type {((inputs?: Changelog_Detail_ErrorInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Detail_ErrorInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_changelog_detail_error(inputs)
	if (locale === "ms") return ms_changelog_detail_error(inputs)
	if (locale === "da") return da_changelog_detail_error(inputs)
	if (locale === "de") return de_changelog_detail_error(inputs)
	if (locale === "en-US") return en_us2_changelog_detail_error(inputs)
	if (locale === "es-ES") return es_es2_changelog_detail_error(inputs)
	if (locale === "es-MX") return es_mx2_changelog_detail_error(inputs)
	if (locale === "fil") return fil_changelog_detail_error(inputs)
	if (locale === "fr") return fr_changelog_detail_error(inputs)
	if (locale === "it") return it_changelog_detail_error(inputs)
	if (locale === "hu") return hu_changelog_detail_error(inputs)
	if (locale === "nl") return nl_changelog_detail_error(inputs)
	if (locale === "no") return no_changelog_detail_error(inputs)
	if (locale === "pl") return pl_changelog_detail_error(inputs)
	if (locale === "pt-BR") return pt_br2_changelog_detail_error(inputs)
	if (locale === "pt") return pt_changelog_detail_error(inputs)
	if (locale === "ro") return ro_changelog_detail_error(inputs)
	if (locale === "fi") return fi_changelog_detail_error(inputs)
	if (locale === "sv") return sv_changelog_detail_error(inputs)
	if (locale === "vi") return vi_changelog_detail_error(inputs)
	if (locale === "tr") return tr_changelog_detail_error(inputs)
	if (locale === "cs") return cs_changelog_detail_error(inputs)
	if (locale === "bg") return bg_changelog_detail_error(inputs)
	if (locale === "ru") return ru_changelog_detail_error(inputs)
	if (locale === "uk") return uk_changelog_detail_error(inputs)
	if (locale === "ar") return ar_changelog_detail_error(inputs)
	if (locale === "hi") return hi_changelog_detail_error(inputs)
	if (locale === "th") return th_changelog_detail_error(inputs)
	if (locale === "ja") return ja_changelog_detail_error(inputs)
	if (locale === "zh-CN") return zh_cn2_changelog_detail_error(inputs)
	if (locale === "zh-Hant") return zh_hant1_changelog_detail_error(inputs)
	return ko_changelog_detail_error(inputs)
});
export { changelog_detail_error as "changelog.detail.error" }